/**
 * Mapping between old custom icon names and Lucide Vue icons
 * This file helps with the migration from custom SVG icons to Lucide Vue
 */

import {
  X,
  Trash2,
  Pencil,
  Copy,
  RotateCw,
  RotateCcw,
  Plus,
  Download,
  Share2,
  Zap,
  ChevronRight,
  ChevronLeft,
  ChevronDown,
  ChevronUp,
  ArrowRight,
  ArrowLeft,
  ArrowUp,
  ArrowDown,
  Menu,
  Check,
  AlertCircle,
  XCircle,
  Info,
  CheckCircle,
  HelpCircle,
  Database,
  BarChart3,
  Table2,
  FileText,
  Folder,
  Filter,
  Search,
  ArrowUpDown,
  Mic,
  MicOff,
  Video,
  Image,
  Volume2,
  VolumeX,
  Play,
  Pause,
  Minimize,
  Maximize2,
  Pin,
  X as PinOff,
  Star,
  Expand,
  Settings,
  Bell,
  Clock,
  Send,
  MessageSquare,
  MessageCircle,
  Bell as NotificationBell,
  Mail,
  Phone,
  Users,
  User,
  LogOut,
  ExternalLink,
  Loader2,
  Calendar,
  Lock,
  Archive,
  ArchiveRestore,
  Eye,
  EyeOff,
  ToggleLeft,
  ToggleRight,
  Building2,
  type LucideIcon
} from 'lucide-vue-next'

export const LUCIDE_ICON_MAP: Record<string, LucideIcon> = {
  // Action icons
  close: X,
  X: X,
  trash: Trash2,
  Trash2: Trash2,
  edit: Pencil,
  Edit: Pencil,
  copy: Copy,
  refresh: RotateCw,
  add: Plus,
  Plus: Plus,
  download: Download,
  share: Share2,
  lightning: Zap,

  // Navigation icons
  chevronRight: ChevronRight,
  chevronLeft: ChevronLeft,
  chevronDown: ChevronDown,
  chevronUp: ChevronUp,
  arrowRight: ArrowRight,
  arrowLeft: ArrowLeft,
  ArrowLeft: ArrowLeft,
  arrowUp: ArrowUp,
  arrowDown: ArrowDown,
  menu: Menu,

  // Status icons
  check: Check,
  warning: AlertCircle,
  error: XCircle,
  info: Info,
  success: CheckCircle,
  helpCircle: HelpCircle,

  // Data icons
  database: Database,
  Database: Database,
  chart: BarChart3,
  table: Table2,
  document: FileText,
  folder: Folder,
  filter: Filter,
  search: Search,
  sort: ArrowUpDown,
  Building2: Building2,

  // Media icons
  microphone: Mic,
  microphoneOff: MicOff,
  camera: Video,
  image: Image,
  volume: Volume2,
  volumeOff: VolumeX,
  play: Play,
  Play: Play,
  pause: Pause,
  Pause: Pause,

  // UI icons
  expand: Expand,
  minimize: Minimize,
  maximize: Maximize2,
  pin: Pin,
  unpin: PinOff,
  star: Star,
  fullscreen: Maximize2,
  settings: Settings,
  bell: Bell,
  clock: Clock,

  // Communication icons
  send: Send,
  message: MessageSquare,
  chat: MessageCircle,
  notification: NotificationBell,
  mail: Mail,
  phone: Phone,
  users: Users,
  user: User,
  logout: LogOut,

  // Additional icons for main module
  rotateReverse: RotateCcw,
  externalLink: ExternalLink,
  loader: Loader2,
  Loader2: Loader2,
  calendar: Calendar,
  lock: Lock,
  Check: Check,
  archive: Archive,
  archiveRestore: ArchiveRestore,
  eye: Eye,
  eyeOff: EyeOff,
  toggle: ToggleRight,
  toggleLeft: ToggleLeft,
  toggleRight: ToggleRight
} as const

export type IconName = keyof typeof LUCIDE_ICON_MAP
